var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt-3"},[_c('ClubIcon',{attrs:{"name":_vm.name,"shield":_vm.shield,"ball":_vm.ball}}),_c('div',{staticClass:"competition-team-name"},[_vm._v(" "+_vm._s(_vm.name)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }